import IconButton from '@mui/joy/IconButton'
import Download from '@mui/icons-material/Download'

export const DownloadButton = (props) => (
    <IconButton variant="outlined" color="primary" {...props}>
        <Download />
    </IconButton>
)
